import { ReactNode, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { KnownHostnames, paths } from "../types/Defaults";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { HomePortfoliosTicker } from "./HomePortfoliosTicker";
import { PortfolioHomeLongOnly } from "./PortfolioHomeLongOnly";
import { PortfolioHomeClassic } from "./PortfolioHomeClassic";
import { PortfolioHomeLongShort } from "./PortfolioHomeLongShort";
import { useShowStickyOnMount } from "../hooks/useStikyMessage";
import { Loader } from "../components/Loader";

type HomeWrapProps = {
  children?: ReactNode;
  isLogged: boolean;
  viewType: "longOnly" | "longShort" | "portfolios";
};

const HomeWrap = ({ children, isLogged, viewType }: HomeWrapProps) => {
  return (
    <div className="d-flex min-vh-100 position-relative">
      <div className="position-absolute top-0 start-0 bottom-0 end-0 home-cover"></div>
      <div className="home-cover position-relative cover-container d-flex min-vh-100 mx-auto flex-column w-100">
        {/* <div className="home-cover-mask position-absolute start-0 end-0 top-0 bottom-0"></div> */}
        {/*Keep this comment 
                {isLogged ? (
                    <Header
                        children={
                            <div className="d-flex justify-content-center">
                                <Link
                                    to={paths.product}
                                    className="btn btn-outline-light ms-2"
                                >
                                    Go to Catalog
                                </Link>
                            </div>
                        }
                    />
                ) : (
                    <Header />
                )}*/}
        <Header
          viewType={viewType}
          children={
            <div className="d-flex justify-content-center">
              <Link
                to={paths.product}
                className="btn btn-outline-light ms-2 rounded"
              >
                Discover our Model Portfolios
              </Link>
            </div>
          }
        />
        <main
          className="main-no-bg flex-grow-1"
          style={{ overflowX: "hidden" }}
        >
          {children}
        </main>
        <Footer />
      </div>
    </div>
  );
};

export const Home = () => {
  const { isLogged, isReady } = useAuth();
  const hostname: KnownHostnames = window.location.hostname as KnownHostnames;
  const [viewType, setViewType] = useState<
    "longOnly" | "longShort" | "portfolios"
  >("longOnly");

  const portfolioViewType: "longOnly" | "longShort" | "portfolios" =
    "portfolios";
  useShowStickyOnMount();
  // Check cookie before setting disclaimer status
  useEffect(() => {
    switch (hostname) {
      // case "longonly.trendrating.com":
      //   setViewType("longOnly");

      //   break;
      case "longshort.trendrating.com":
      case "longshortd.trendrating.com":
        setViewType("longShort");

        break;

      case "systematicgain.com":
      case "systematicgains.com":
      case "www.systematicgains.com":
      case "longonly.trendrating.com":
      case "portfolios.trendrating.com":
      case "develop.portfolios.trendrating.com":
      case "localhost":
        setViewType(portfolioViewType);

        break;

      default:
        setViewType("portfolios");
    }
  }, [hostname]);

  // useEffect(() => {
  //   // This delayed the entry of the CTA if you want to renable this uncomment
  //   // const handleIntersection = (entries: any, observer: any) => {
  //   //   entries.forEach((entry: any) => {
  //   //     if (entry.isIntersecting) {
  //   //       // Delay the appearance of the sticky message
  //   //       setTimeout(() => {
  //   //         ctx?.setShowSticky(true);
  //   //         observer.unobserve(entry.target);
  //   //       }, 500);
  //   //     }

  //   //   });
  //   // };

  //   // const target = document.querySelector("#messageAnchor");

  //   // if (target != null) {
  //   //   const observer = new IntersectionObserver(handleIntersection);

  //   //   observer.observe(target);

  //   //   return () => {
  //   //     observer.unobserve(target);
  //   //   };
  //   // }

  // }, [ctx, isReady]);

  if (!isReady) {
    return (
      <HomeWrap isLogged={isLogged} viewType={viewType}>
        <div className="home-header">
          <div className="home-header-content">
            <Container className="home-header-content">
              <Row>
                <Col md={12} className="home-header-top">
                  <Loader message="Loading..." showMessage={true} fullPage />
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </HomeWrap>
    );
  }

  return (
    <HomeWrap isLogged={isLogged} viewType={viewType}>
      <div className="home-header">
        <div className="home-header-content home-header-content--part1">
          <div className="home-header-content-mask"></div>
          <Container className="">
            <Row className="home-header-bottom-divider">
              <Col md={12} className="home-header-content-cell">
                <div className="home-header-top  d-flex flex-column justify-content-between gap-3">
                  <ul
                    style={{
                      fontSize: "26px",
                      listStyle: "none",
                    }}
                    className="d-flex flex-column gap-1 mt-3 p-5"
                  >
                    <li>
                      <h3>
                        Maximize the potential of your equity investments.
                      </h3>
                    </li>
                    <li>
                      <h3>Explore our AI-driven model portfolios.</h3>
                    </li>
                    <li>
                      <h3>Compare, decide.</h3>
                    </li>
                  </ul>
                  <h1 className="d-flex">
                    <span className="home-header-title flex-grow-1 flex-shrink-1">
                      SYSTEMATIC MODEL PORTFOLIOS
                      <br />
                      {viewType === "longShort" && "LONG AND SHORT"}
                      {viewType === "longOnly" && "LONG ONLY"}
                    </span>
                    <span></span>
                  </h1>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <HomePortfoliosTicker />
        <div id="messageAnchor"></div>
        {viewType === "longOnly" && <PortfolioHomeLongOnly />}
        {viewType === "portfolios" && <PortfolioHomeClassic />}
        {viewType === "longShort" && <PortfolioHomeLongShort />}
      </div>
    </HomeWrap>
  );
};
